<template>
  <v-container
    id="data-tables"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="2">
        <v-card>
          <v-card-text>
            <v-treeview
              :items="folders"
              activatable
              return-object
              @update:active="TreeClick"
              @update:open="TreeOpen"
            >
              <template v-slot:prepend="{ item, open }">
                <v-icon v-if="item.action != 'new'">
                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
                <v-icon v-else>
                  mdi-plus
                </v-icon>
              </template>
              <template v-slot:append="{ item, open }">
                <v-icon
                  v-if="$store.state.access[11][3]"
                  @click="edit_folder(item)"
                >
                  mdi-pen
                </v-icon>
                <v-icon
                  v-if="$store.state.access[11][3]"
                  @click="delete_folder(item, open)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="10"
      >
        <base-v-component
          heading="Список документов"
        />
        <base-material-card
          color="primary"
          icon="mdi-file-document"
          inline
        >
          <template v-slot:after-heading>
            <div class="text-h3 font-weight-light">
              Документы
            </div>
          </template>
          <v-progress-linear
            class="ma-0"
            color="primary"
            :indeterminate="loader.show"
          />
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              multi-sort
              :footer-props="datatable_footer"
              :search.sync="search"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="7">
                        <div class="search-row">
                          <v-icon
                            class="mr-3 mt-1"
                            @click="show_header_dialog"
                          >
                            mdi-menu
                          </v-icon>
                          <span class="search-title">Поиск</span>
                          <v-text-field
                            v-model="search"
                            clearable
                          />
                        </div>
                      </v-col>
                      <v-col cols="5">
                        <v-icon
                          large
                          :color="filter.set?'black':'grey lighten-2'"
                          @click="filter_dialog = true;"
                        >
                          mdi-filter-outline
                        </v-icon>
                        <v-icon
                          small
                          class="mr-5"
                          :color="filter.set?'black':'white'"
                          @click="clear_filter"
                        >
                          mdi-close
                        </v-icon>
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          @click="load"
                        >
                          <v-icon>
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.save="{item}">
                <v-icon @click="getDoc(item)">
                  mdi-download
                </v-icon>
              </template>
              <template v-slot:item.comment="{item}">
                <v-text-field
                  v-model="item.comment"
                  :disabled="!$store.state.access[10][3]"
                  label="Описание"
                  @input="item.edited = true"
                />
              </template>
              <template v-slot:item.number="{item}">
                <v-text-field
                  v-model="item.number"
                  :disabled="!$store.state.access[10][3]"
                  label="Номер"
                  @input="item.edited = true"
                />
              </template>
              <template v-slot:item.date="{item}">
                <v-text-field
                  v-model="item.date"
                  :disabled="!$store.state.access[10][3]"
                  label="Дата подписания"
                  type="date"
                  @input="item.edited = true"
                />
              </template>
              <template v-slot:item.action="{item}">
                <v-icon
                  v-if="$store.state.access[10][3]"
                  @click="DeleteItem(item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  v-if="$store.state.access[10][3] && item.edited"
                  @click="SaveItem(item)"
                >
                  mdi-content-save
                </v-icon>
              </template>

              <template v-slot:item.created="{item}">
                {{ format(item.created) }}
              </template>
              <template v-slot:item.size="{item}">
                {{ format_size(item.size) }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="grey lighten-4">
            <v-btn
              v-if="$store.state.access[10][5]"
              color="primary"
              text
              :disabled="loader.show"
              @click="$refs.upload.click()"
            >
              Добавить файл
            </v-btn>
            <input
              ref="upload"
              type="file"
              style="display: none;"
              @change="upload_file"
            >
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <v-card class="filter_popup">
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs vertical>
              <v-tab
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                {{ tab.name }}<v-icon left>
                  mdi-star
                </v-icon>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="changeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-text-field
                        v-else
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary darken-1"
              text
              @click="filter_dialog = false"
            >
              Закрыть
            </v-btn>
            <v-btn
              color="primary darken-1"
              text
              @click="filter_dialog = false, set_filter()"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <v-card class="filter_popup">
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary darken-1"
              text
              @click="dialog.headers.show = false"
            >
              Закрыть
            </v-btn>
            <v-btn
              color="primary darken-1"
              text
              @click="dialog.headers.show = false, set_headers()"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.folder.show"
        max-width="400"
      >
        <v-card>
          <v-card-title>Введите название папки</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="dialog.folder.name"
              label="Название"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="!dialog.folder.id"
              color="primary"
              @click="create_folder"
            >
              Создать
            </v-btn>
            <v-btn
              v-else
              color="primary"
              @click="save_folder"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<style lang="scss">
/**popup */
.filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
  display: flex;
  flex-direction: column;
  height: 80px;
  width: 100px;
  font-size: 0.6rem !important;
  line-height: 0.8rem;
  white-space: pre-wrap;
}
@media (min-width: 960px) {
  .filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
    flex-direction: row;
    height: 50px;
    width: 150px;
    font-size: 0.70rem !important;
    line-height: 0.8rem;
    white-space: pre-wrap;
  }
}
/** _popup */

.search-row{
  display: flex;
  flex-direction: row;
}
.search-title {
  padding-top: 24px;
  padding-right: 10px;
  margin-top: 4px;
  font-size: 1.6rem;
  color: #ec7e2f;
}
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
import moment from 'moment'
import $ from 'jquery'
import { truncate } from 'fs'
import { parse } from 'path'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      folders: [],
      search: '',
      loader: {
        show: false
      },
      dialog: {
        headers: {
          show: false
        },
        folder: {
          show: false
        }
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      headers: [
        {
          text: 'Действие',
          value: 'action',
          active: true,
          active_temp: true
        },
        {
            text: '',
            value: 'save',
            active: true,
            active_temp: true

          },
          {
            text: 'Название',
            value: 'name',
            active: true,
            active_temp: true
          },
          {
            text: 'Тип',
            value: 'ext',
            active: true,
            active_temp: true
          },
          {
            text: 'Размер',
            value: 'size',
            active: true,
            active_temp: true
          },
          {
            text: 'Дата',
            value: 'created',
            active: true,
            active_temp: true
          },
          {
            text: 'Дата подписания',
            value: 'date',
            active: true,
            active_temp: true
          },
          {
            text: 'Номер документа',
            value: 'number',
            active: true,
            active_temp: true
          },
          {
            text: 'Описание',
            value: 'comment',
            active: true,
            active_temp: true
          },
      ],
      doc_type: {

      },
      items: [],
      form: {

      },
      search: "",
      select: {
      },
      dict: {

      },
      folder: '',
      filter_dialog: false,
      filter_fields: {
        common: {
          name: "Основное",
          active: true,
          data: [
            {
              name: "Номер",
              data: "number",
              type: "text",
            },
            {
              name: "Наименование",
              data: "name",
              type: "text",
            },
            {
              name: "Дата подписания",
              data: "date",
              type: "date",
            },
            {
              name: "Дата загрузки",
              data: "created",
              type: "date",
            },
          ]
        },
      },
      filter: {
        set: false
      },
    }),
    computed: {
      max_date: function () {
        return moment().format('YYYY-MM-DD')
      },
    },
    mounted: function () {
      this.load_folders()
      this.load()
    },
    methods: {
      load_folders: function () {
        this.axios.post('/api/folder/list', {})
          .then(result => {
            this.loading = false
            if (!result.data.error) {
              this.folders = this.GetTreeView(result.data.data)
            } else {
              this.$store.commit('snackbar', 'Ошибка при загрузке')
            }
          })
          .catch(error => {
            this.loading = false
            console.log(error)
            this.$store.commit('snackbar', 'Ошибка при загрузке')
          })
      },
      TreeOpen: function (items) {
        var item = items[0]
        if (item) {
          this.folder = item.id
        }
        this.load()
      },
      TreeClick: function (items) {
        var item = items[0]
        if (item) {
          if (item.action == 'new') {
            this.dialog.folder.name = 'Новая папка'
            this.dialog.folder.parent = item.parent
            this.dialog.folder.show = true
            this.folder = item.parent
          } else {
            this.folder = item.id
            this.load()
          }
        }
      },
      edit_folder: function (folder) {
        this.dialog.folder.name = folder.name
        this.dialog.folder.parent = folder.parent
        this.dialog.folder.id = folder.id
        this.dialog.folder.show = true
      },
      save_folder: function () {
        this.axios.post('/api/folder/update', {
                id: this.dialog.folder.id,
                name: this.dialog.folder.name,
                parent: this.dialog.folder.parent
            })
          .then(result => {
            this.load_folders()
            this.dialog.folder.show = false
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('snackbar', 'Ошибка при создании')
          })
      },
      create_folder: function () {
        this.axios.post('/api/folder/create', {
                name: this.dialog.folder.name,
                parent: this.dialog.folder.parent
            })
          .then(result => {
            this.load_folders()
            this.dialog.folder.show = false
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('snackbar', 'Ошибка при создании')
          })
      },
      GetTreeView: function (data) {
        var tree = [
          {
            name: 'Все файлы',
            id: null,
            children: []
          },
        ]
        console.log(data)
        for (const x in data.filter(a => !a.parent)) {
          var children = this.FillTree(data, data.filter(a => !a.parent)[x].id)
          if (this.$store.state.access[11][5]) {
            children.push({
                id: data.filter(a => !a.parent)[x].id + 'new',
                name: 'Добавить папку',
                parent: data.filter(a => !a.parent)[x].id,
                action: 'new'
            })
          }
          tree.push({
            name: data.filter(a => !a.parent)[x].name,
            id: data.filter(a => !a.parent)[x].id,
            children: children
          })
        }
        if (this.$store.state.access[11][5]) {
          tree.push({
              id: 'new',
              name: 'Добавить папку',
              parent: null,
              action: 'new'
          })
        }
        return tree
      },
      FillTree: function (data, parent) {
        var tree = []
        for (const x in data.filter(a => a.parent == parent)) {
          console.log(data.filter(a => a.parent == parent)[x].id)
          var children = this.FillTree(data, data.filter(a => a.parent == parent)[x].id)
          if (this.$store.state.access[11][5]) {
            children.push({
                id: data.filter(a => a.parent == parent)[x].id + 'new',
                name: 'Добавить папку',
                parent: data.filter(a => a.parent == parent)[x].id,
                action: 'new'
            })
          }
          tree.push({
            name: data.filter(a => a.parent == parent)[x].name,
            id: data.filter(a => a.parent == parent)[x].id,
            children: children
          })
        }
        return tree
      },
      format_size: function (size) {
        if (size < 1024) {
          return size + ' байт'
        } else {
          var kb = size / 1024
          if (kb < 1024) {
            return (Number(kb).toFixed(2) + ' кбайт')
          } else {
            var mb = kb / 1024
            return (Number(mb).toFixed(2) + ' мбайт')
          }
        }
      },
      format: function (date) {
        if (!date) return ''
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      upload_file: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          data.append('folder', this.folder)
          this.axios
            .post('/api/document/create/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.items.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      DeleteItem: function (item) {
        this.sheet = false
        if (confirm('Вы уверены?')) {
          item.deleted = true
          this.axios.post('/api/document/update', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Удаление успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при удалении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при удалении')
            })
        }
      },
      delete_folder: function (item, open) {
        open = false
        if (confirm('Вы уверены?')) {
          item.deleted = true
          this.axios.post('/api/folder/update', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Удаление успешно')
                this.load_folders()
              } else {
                this.$store.commit('snackbar', 'Ошибка при удалении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при удалении')
            })
        }
      },
      SaveItem: function (item) {
        this.sheet = false
          this.axios.post('/api/document/update', item)
            .then(result => {
              this.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Сохранение успешно')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении')
              }
            })
            .catch(error => {
              this.loading = false
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            })
      },
      show_header_dialog: function () {
        for (const x in this.headers) {
          this.headers[x].active_temp = this.headers[x].active
        }
        this.dialog.headers.show = true
      },
      set_headers: function () {
        for (const x in this.headers) {
          this.headers[x].active = this.headers[x].active_temp
        }
        this.$axios.post('/api/user/headers', {
          entity: 'document',
          headers: this.headers.filter(a => a.active).map(a => a.value)
        })
        .catch(e => {
          console.log(e)
        })
      },
      fill_dict: function (data, dict) {
        data.select = []
        for (const x in dict) {
          data.select.push({ value: Number(x), text: dict[x].name })
        }
      },
      set_filter: function (flag) {
        if (this.filter.changed) this.filter.set = true
        this.filter.changed = false
        this.load()
      },
      clear_filter: function () {
        this.filter.set = false
        for (const x in this.filter_fields) {
          for (const y in this.filter_fields[x].data) {
             this.filter_fields[x].data[y].value = ''
             this.filter_fields[x].data[y].from = ''
             this.filter_fields[x].data[y].to = ''
          }
        }
      },
      formatInputDate: function (_date) {
        const date = new Date(_date)
        let dd = date.getDate()
        if (dd < 10) dd = '0' + dd

        let mm = date.getMonth() + 1
        if (mm < 10) mm = '0' + mm

        let yyyy = date.getFullYear()
        if (yyyy < 10) yyyy = '0' + yyyy

        return yyyy + '-' + mm + '-' + dd
      },
      changeFilterDateType (value, tab, field) {
        this.filter.changed = true
        console.log('changeFilterDateType', value, tab, field)
        if (tab && field && value) {
          if (value !== 'period' && value !== 'date') {
            let date = 0
            if (value == 'today') {
              date = new Date()
            } else if (value == 'yesterday') {
              date = new Date().setDate(new Date().getDate() - 1)
            } else if (value == 'tomorrow') {
              date = new Date().setDate(new Date().getDate() + 1)
            }
            const formated_date = this.formatInputDate(date)
            field.from = formated_date
            field.to = formated_date
          }
          if (value == 'date') {
            field.to = ''
          }
        }
      },
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
        },
        this.load()
      },
      load: function (clear) {
        const request = JSON.parse(JSON.stringify(this.form))
        if (this.filter.set) {
          request.data = JSON.parse(JSON.stringify(this.filter_fields))
          delete request.data.set
          delete request.data.changed
        }
        request.folder = this.folder
        this.axios.post('/api/document/list', request)
          .then(result => {
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              for (const x in this.items) {
                if (this.items[x].date) this.items[x].date = moment(this.items[x].date).format('YYYY-MM-DD')
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
